package com.bikompanion.data.cache

import kotlinx.serialization.Serializable

@Serializable
internal data class CachedStations(
    val updatedAtEpochMillis: Long,
    val stations: List<CachedStation>,
)
